import React, {useState, useEffect} from 'react';

const BillingFrequency = ({initialValue, onChange}) => {

  const [value, setValue] = useState(initialValue || 'monthly');

  useEffect(() => onChange(value), [value]);

  return <>
    <div className="h5">Billing frequency</div>
    <div className="ms-md-4">
      <div className="form-check">
        <input id="billingFrequencyMonthly" name="billingFrequency"
               type="radio"
               className="form-check-input"
               value="monthly"
               checked={value === 'monthly'}
               onChange={e => setValue(e.target.value)}/>
        <label className="form-check-label" htmlFor="billingFrequencyMonthly">
          Monthly
        </label>
      </div>
      <div className="form-check">
        <input id="billingFrequencyYearly" name="billingFrequency"
               type="radio"
               className="form-check-input"
               value="yearly"
               checked={value === 'yearly'}
               onChange={e => setValue(e.target.value)}/>
        <label className="form-check-label" htmlFor="billingFrequencyYearly">
          Yearly <div className="badge rounded-pill bg-success ms-2" style={{fontSize: '.9em'}}>Save 20%</div>
        </label>
      </div>
    </div>
  </>;
};

export default BillingFrequency;
